import { CoreEntityDto } from '@/interfaces/core.interface'
import {
  CoreEntityPageParams,
  fetchCoreEntityPage,
  fetchCoreEntity,
  fetchCoreEntityParents,
  UpdateCoreEntityDto,
  updateCoreEntity
} from '@/services/core.service'
import { defineStore } from 'pinia'

export const useCoreEntityStore = defineStore('coreEntity', () => {
  const coreEntities: Record<string, CoreEntityDto> = {}
  const coreEntityPages: Record<string, CoreEntityDto[]> = {}
  const coreEntityParents: Record<string, CoreEntityDto[]> = {}

  async function getCoreEntity(id: string): Promise<CoreEntityDto> {
    const cached = coreEntities[id]
    if (cached) return cached
    const entity = await fetchCoreEntity(id, true)
    coreEntities[id] = entity
    return entity
  }

  async function getCoreEntityPage(params: CoreEntityPageParams): Promise<CoreEntityDto[]> {
    const key = JSON.stringify(params)
    const cached = coreEntityPages[key]
    if (cached) return cached
    const page = await fetchCoreEntityPage(params)
    coreEntityPages[key] = page.items
    if (params.withGeojson) {
      page.items.forEach((entity) => {
        coreEntities[entity.id] = entity
      })
    }
    return page.items
  }

  async function getParents(id: string): Promise<CoreEntityDto[]> {
    const cached = coreEntityParents[id]
    if (cached) return cached
    const parents = await fetchCoreEntityParents(id)
    coreEntityParents[id] = parents
    return parents
  }

  async function updateById(id: string, data: UpdateCoreEntityDto): Promise<CoreEntityDto> {
    const entity = await updateCoreEntity(id, data)
    coreEntities[id] = entity
    return entity
  }

  return {
    getCoreEntity,
    getCoreEntityPage,
    getParents,
    updateById
  }
})
